<template lang="pug">
    main#reportsPage.browser-default
        Navbar(tab="reports" :siteId="siteId" :site="site")
        main(v-if="site")
            .container
                .app-page-breadcrumbs
                    AppBreadcrumbs(label="Reports" :site="site" :site-id="siteId")
                v-row.top-header
                    .col.s12.site-info
                        .site-image(:style='"background-image:url(" + (site.logo ? site.logo.url.replace("http", "https") : "") + ")"')
                        //- .site-progress
                        //- 	a.modal-trigger(v-if="site.score" href="#modal-score-breakdown" style="color:var(--app-tertiary-txt)")
                        //- 		DonutIndicator(:key="site.objectId+'-pt-donut'" :id="site.objectId +'-scoreOA'" :cssClass="'main-donut'" :value="Math.round(site.scoreOA.curScore)" :size="60")
                        //- 	DonutIndicator(v-else :key="site.objectId+'-pt-donut'" :id="site.objectId +'-scoreOA'" :cssClass="'main-donut'" :value="Math.round(site.scoreOA.curScore)" :size="60")
                        .site-title {{site.name}} Reports 
                .report-setup
                    .report-fields
                        HaqTextField.report-name-field(v-model="reportName" label="Report title" placeholder="e.g. Kinzie - Yesterday's Halo Data" :disabled="disableButtons || generatingPDF || generatingExcel")
                        HaqAutocomplete(v-model="reportTimezone" :items="reportTimezones" label="Report timezone" @change="onTimelineChange(selectedTimeline)" :disabled="disableButtons")
                        HaqSelect(
                            label="Time period"
                            v-model="selectedTimeline"
                            :items="timelineOptions"
                            item-text="label"
                            item-value="value"
                            @change="onTimelineChange"
                            :disabled="disableButtons"
                        )
                    .report-custom-dates(v-if="selectedTimeline === 'custom'")
                        DatePicker(:date="startDate" v-on:dateChange="updateStartDate" label="Start Date")
                        DatePicker(:date="endDate" v-on:dateChange="updateEndDate" label="End Date")
                    .report-actions
                        v-btn.haq-btn.haq-btn-secondary.measurement-chips-btn(text @click="selectMeasurementDialog = true" :disabled="disableButtons")
                            span.mr-2 Select devices & measurements
                            v-chip(small) {{selectedMeasurements.length}}
                        v-btn.haq-btn.haq-btn-primary(text :disabled="disableButtons || !selectedMeasurements.length" @click="generateReport") Generate report
                        v-btn.haq-btn.haq-btn-secondary(@click="openScheduleDialog" :disabled="selectedTimeline === 'custom' || !selectedMeasurements.length || disableButtons") Schedule report
                    p.report-setup-help Select measurements from one or more devices, then generate a report or schedule recurring delivery.
                    p.report-selection-summary(v-if="selectedMeasurements.length") {{ selectedMeasurements.length }} measurements across {{ selectedDeviceNames.length }} devices/zones: {{ selectedDeviceNames.join(', ') }}
                #reportsDiv(v-if="report")
                    v-row
                        v-col(:cols="12" :sm="12").d-flex.flex-column
                            .d-flex.align-center.flex-wrap
                                v-btn.haq-btn.haq-btn-secondary.mr-4.mb-2(@click="downloadPDF()" :loading="generatingPDF" :disabled="generatingPDF || generatingExcel || disableButtons") 
                                    span(v-if="!generatingPDF") Download PDF
                                    span(v-else) Generating PDF...
                                v-btn.haq-btn.haq-btn-secondary.mr-4.mb-2(@click="downloadExcel()" :loading="generatingExcel" :disabled="disableButtons || generatingPDF || generatingExcel")
                                    span(v-if="!generatingExcel") Download Excel
                                    span(v-else) Generating Excel...
                                v-switch.excel-trend-switch.mt-0.mb-2.mr-4(
                                    v-model="includeTrendData"
                                    label="Include trend data"
                                    color="primary"
                                    dense
                                    hide-details
                                    :disabled="generatingExcel || generatingPDF || disableButtons"
                                )
                                v-tooltip(top :disabled="selectedTimeline !== 'custom'")
                                    template(v-slot:activator="{ on, attrs }")
                                        span(v-bind="attrs" v-on="on")
                                            v-btn.haq-btn.haq-btn-primary.mb-2(
                                                @click="openScheduleDialog"
                                                :disabled="selectedTimeline === 'custom' || disableButtons"
                                            )
                                                v-icon(left small) mdi-clock-outline
                                                | Schedule Report
                                    span Scheduled reports are only available for non-custom timelines
                            .mt-2(v-if="generatingPDF && pdfProgress")
                                v-progress-linear(indeterminate color="blue")
                                small.ml-2 {{pdfProgress}}
                            .mt-2(v-if="generatingExcel && excelProgress")
                                v-progress-linear(indeterminate color="blue")
                                small.ml-2 {{excelProgress}}
                    v-row(v-for="d,index in report.data" :key="index")
                        v-col(:cols="12" :sm="12")
                            v-card.measurement-report-card
                                v-card-title {{ getDisplayName(d) }}
                                v-card-text
                                    v-simple-table.measurement-report-table(:data-measurement-kind="d.measurementKind")
                                        thead(v-if="d.measurementKind === 'Bool'")
                                            tr
                                                th Time Range
                                                th Count
                                        tbody(v-if="d.measurementKind === 'Bool'")
                                            tr(v-for="i,intervalIdex in d.intervals" :key="intervalIdex")
                                                td {{i.intervalName}}
                                                td  {{i.count}}
                                        template(v-slot:default v-if="d.measurementKind !== 'Bool'")
                                            thead
                                                tr
                                                    th Time Range
                                                    th Min Value
                                                    th Max Value
                                                    th Average Value
                                                    th(v-if="showScore") Min Score
                                                    th(v-if="showScore")  Max Score
                                                    th(v-if="showScore")  Average Score
                                            tbody
                                                tr(v-for="i,intervalIdex in d.intervals" :key="intervalIdex")
                                                    td {{i.intervalName}}
                                                    td  {{i.minVal}}
                                                    td {{i.maxVal}}
                                                    td {{Math.round(i.aveVal * 100)/100}}
                                                    td(v-if="showScore")  {{Math.round(i.minScore * 100)/100}}
                                                    td(v-if="showScore")  {{Math.round(i.maxScore * 100)/100}}
                                                    td(v-if="showScore")  {{Math.round(i.aveScore * 100)/100}}
                        v-col(:cols="12" :sm="12")
                            ReportChart(:report="d" :ref="'reportChart-' + index")
                //- Scheduled Reports Table (collapsible)
                ScheduledReportsTable(
                    :siteId="siteId"
                    :scheduledReports="scheduledReports"
                    :loading="loadingScheduledReports"
                    :previewingId="previewingId"
                    @preview="previewScheduledReport"
                    @edit="editScheduledReport"
                    @delete="deleteScheduledReport"
                    @refresh="loadScheduledReports"
                )
                v-dialog(v-model="selectMeasurementDialog" content-class="haq-dialog multiMeasurementSelectorModal" scrollable)
                    MultiMeasurementSelector(v-if="selectMeasurementDialog" :preSelectedMeasurements="selectedMeasurements" v-on:addMeasurements="addMeasurements"
                    v-on:closeModal="selectMeasurementDialog=false")
                //- Schedule Report Modal
                ScheduleReportModal(
                    v-model="scheduleDialogOpen"
                    :siteId="siteId"
                    :timeline="selectedTimeline"
                    :measurements="selectedMeasurements"
                    :editingSchedule="editingSchedule"
                    :reportName="reportName"
                    :reportTimezone="reportTimezone"
                    @saved="onScheduleSaved"
                    @close="closeScheduleDialog"
                )
</template>

<style lang="scss" scoped>
    .report-setup {
        margin: 4px 0 24px;
    }
    .report-fields {
        display: grid;
        grid-template-columns: minmax(0, 2fr) minmax(0, 1.3fr) minmax(160px, 0.8fr);
        gap: 20px;
        align-items: start;
        > * { min-width: 0; }
    }
    .report-custom-dates {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 240px));
        gap: 20px;
        margin-top: 20px;
    }
    .report-actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px;
        margin-top: 24px;
        .v-btn.haq-btn {
            height: 44px !important;
            margin: 0 !important;
            letter-spacing: 0.3px !important;
        }
    }
    .report-setup-help, .report-selection-summary {
        margin: 16px 0 0;
        color: var(--app-secondary-txt);
        font-size: 14px;
        line-height: 1.5;
    }
    .report-selection-summary { overflow-wrap: anywhere; }
    @media (max-width: 900px) {
        .report-fields { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        .report-name-field { grid-column: 1 / -1; }
    }
    @media (max-width: 600px) {
        .report-fields, .report-custom-dates { grid-template-columns: minmax(0, 1fr); }
        .report-actions .v-btn.haq-btn { width: 100%; }
    }

    .measurement-report-card {
        background-color: var(--app-secondary-bg);
        .measurement-report-table {
             background-color: var(--app-tertiary-bg);
             height: 400px;
             overflow-x: hidden;
             overflow-y: auto;
        }
    }
    .top-header {
		margin-top: 16px;
		margin-bottom: 0;
		.site-info {
			display: flex;
			align-items: center;
			margin-bottom: 20px;
			.site-image {
				border-radius: 20px;
				width: 120px;
				height: 80px;
				min-width: 120px;
				min-height: 80px;
				background-size: cover;
				background-position: 50% 50%;
				background-repeat: no-repeat;
				vertical-align: top;
				margin-right: 2rem;
			}
			.site-progress {
				margin-right: 1.5rem;
			}			
			.site-title {
				color: var(--app-primary-txt);
				font-size: 28px;
				.siteLink {
					color: var(--app-primary-txt);
					&:hover {
						text-decoration: underline;
					}
				}
			}
		}
	}
    
    .haq-btn {
        border-radius: 12px !important;
        padding: 8px 24px !important;
        font-weight: 500 !important;
        text-transform: none !important;
        min-width: 100px !important;
        height: 2.8em !important;
        line-height: 2.8em !important;
        
        &.haq-btn-primary {
            background: var(--score-blue-color) !important;
            color: white !important;
            
            &:hover {
                background: var(--score-blue-color) !important;
                opacity: 0.9 !important;
            }
                
            &:disabled {
                background: var(--app-tertiary-bg) !important;
                color: var(--app-tertiary-txt) !important;
                opacity: 0.6 !important;
            }
        }
        
        &.haq-btn-secondary {
            background: var(--app-tertiary-bg) !important;
            color: var(--app-primary-txt) !important;
            border: 1px solid var(--border) !important;
            
            .v-btn__content {
                color: var(--app-primary-txt) !important;
            }
            
            &:hover {
                background: var(--app-secondary-bg) !important;
            }
        }
    }
    
    .measurement-chips-btn {
        .v-chip {
            background-color: #2d4a8f !important;
            color: white !important;
        }
    }
    
    .excel-trend-switch {
        margin-top: 0 !important;
        padding-top: 0 !important;
        flex: 0 0 auto !important;
        align-self: center;
        ::v-deep .v-input__control {
            min-height: 0 !important;
        }
        ::v-deep .v-input__slot {
            margin: 0 !important;
            min-height: 2.8em !important;
            align-items: center;
        }
        ::v-deep .v-label {
            top: 0 !important;
            margin-bottom: 0 !important;
        }
    }
    
    .csv-info-text {
        color: var(--app-tertiary-txt);
        font-size: 12px;
        display: flex;
        align-items: center;
        
        .v-icon {
            color: var(--app-tertiary-txt);
        }
    }
    
</style>
<script>
import Navbar from '@/components/Navbar.vue';
import MultiMeasurementSelector from '@/components/util/MultiMeasurementSelector'
import DatePicker from '@/components/util/DatePicker.vue';
import ScheduleReportModal from '@/components/reports/ScheduleReportModal.vue';
import ScheduledReportsTable from '@/components/reports/ScheduledReportsTable.vue';
import HaqSelect from '@/components/form/HaqSelect.vue';
import HaqTextField from '@/components/form/HaqTextField.vue';
import HaqAutocomplete from '@/components/form/HaqAutocomplete.vue';
import { useGetSite } from '../assets/js/hawken-query'
import moment from 'moment-timezone'
import {HTTPClient} from '../assets/js/http'
import Axios from 'axios'
import ReportChart from '@/components/reports/chart.vue';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import jsPDF from 'jspdf';
import Highcharts from 'highcharts';
import HighchartsExporting from 'highcharts/modules/exporting';
import { buildSummaryRows } from '../assets/js/reportWorkbook';
import { createReportWorkbookWorker } from '../assets/js/reportWorkbookWorker';

// Initialize Highcharts exporting module
HighchartsExporting(Highcharts);

let client = new HTTPClient();
export default {
    name: "Reports",
    components: {
        Navbar,
        DatePicker,
        MultiMeasurementSelector,
        ReportChart,
        ScheduleReportModal,
        ScheduledReportsTable,
        AppBreadcrumbs,
        HaqSelect,
        HaqTextField,
        HaqAutocomplete
    },
    data(){
        return {
            loadedAt: new Date().valueOf(),
            siteId: this.$route.params.siteId,
            site: null,
            timeperiodOptions: ["Daily", "Weekly", "Monthy"],
            timeperiod: "Daily",
            // report: JSON.parse(localStorage.getItem("report")),
            report: null,
            reportName: '',
            reportTimezone: 'America/Chicago',
            reportTimezones: moment.tz.names(),
            includesScores: true,
            selectedMeasurements: [],
            selectMeasurementDialog: false,
            disableButtons: false,
            startDate: moment().subtract(7, "days").valueOf(),
            endDate: moment().startOf("day").valueOf(),
            generatingPDF: false,
            pdfProgress: '',
            generatingExcel: false,
            excelProgress: '',
            includeTrendData: false,
            // Timeline selection
            selectedTimeline: 'lastWeek',
            timelineOptions: [
                { label: 'Yesterday', value: 'yesterday' },
                { label: 'Last Week', value: 'lastWeek' },
                { label: 'Last Month', value: 'lastMonth' },
                { label: 'Custom', value: 'custom' }
            ],
            // Scheduled reports
            scheduleDialogOpen: false,
            scheduledReports: [],
            loadingScheduledReports: false,
            editingSchedule: null,
            previewingId: '',
        }
    },
    methods: {
        /**
         * Sync siteId from the route and reload page data.
         */
        reloadFromRoute() {
            const siteId = this.$route.params.siteId || this.$route.query.siteId;
            if (!siteId) return;
            this.siteId = siteId;
            this.report = null;
            this.selectedMeasurements = [];
            this.reportName = '';
            this.loadOptions();
        },
        async loadOptions(){
            try {
                this.site = await useGetSite(this.siteId)
                this.onTimelineChange(this.selectedTimeline)
                // Load scheduled reports after site is loaded
                await this.loadScheduledReports()
            } catch (error) {
                console.error(error)
            }
        },
        addMeasurements(m){
            this.report = null;
            this.selectedMeasurements = m;
            // console.log(m);
            this.selectMeasurementDialog = false
        },
        /**
         * Handle timeline dropdown change
         * Updates the date range based on selected timeline
         */
        onTimelineChange(timeline) {
            const now = moment().tz(this.reportTimezone);
            switch (timeline) {
                case 'yesterday':
                    this.startDate = now.clone().subtract(1, 'day').startOf('day').valueOf();
                    this.endDate = now.clone().subtract(1, 'day').endOf('day').valueOf();
                    break;
                case 'lastWeek':
                    this.startDate = now.clone().subtract(7, 'days').startOf('day').valueOf();
                    this.endDate = now.clone().subtract(1, 'day').endOf('day').valueOf();
                    break;
                case 'lastMonth':
                    this.startDate = now.clone().subtract(30, 'days').startOf('day').valueOf();
                    this.endDate = now.clone().subtract(1, 'day').endOf('day').valueOf();
                    break;
                case 'custom':
                    // Keep current dates for custom
                    break;
            }
        },
        /**
         * Open the schedule report dialog
         */
        openScheduleDialog() {
            if (this.selectedMeasurements.length < 1) {
                window.M.toast({ html: "Please select measurements first" });
                return;
            }
            this.editingSchedule = null;
            this.scheduleDialogOpen = true;
        },
        /**
         * Close the schedule dialog and reset editing state
         */
        closeScheduleDialog() {
            this.scheduleDialogOpen = false;
            this.editingSchedule = null;
        },
        /**
         * Handle when a schedule is saved (created or updated)
         */
        async onScheduleSaved() {
            this.closeScheduleDialog();
            await this.loadScheduledReports();
            window.M.toast({ html: "Schedule saved successfully" });
        },
        /**
         * Load all scheduled reports for the site
         */
        async loadScheduledReports() {
            try {
                this.loadingScheduledReports = true;
                const res = await client.robustQuery(`/api/sites/${this.siteId}/scheduled-reports`);
                this.scheduledReports = res.results || [];
            } catch (error) {
                console.error('Failed to load scheduled reports:', error);
                this.scheduledReports = [];
            } finally {
                this.loadingScheduledReports = false;
            }
        },
        /**
         * Open the edit dialog for a scheduled report
         */
        editScheduledReport(schedule) {
            this.editingSchedule = schedule;
            this.scheduleDialogOpen = true;
        },
        /**
         * Delete a scheduled report
         */
        async deleteScheduledReport(schedule) {
            try {
                await Axios.delete(`/api/sites/${this.siteId}/scheduled-reports/${schedule.id}`);
                await this.loadScheduledReports();
                window.M.toast({ html: "Schedule deleted successfully" });
            } catch (error) {
                console.error('Failed to delete scheduled report:', error);
                window.M.toast({ html: "Failed to delete schedule" });
            }
        },
        /**
         * @description Download the saved schedule through the delivery renderer without sending email.
         * @param {object} selection Selected schedule and output format.
         */
        async previewScheduledReport({ schedule, format }) {
            if (this.previewingId) return;
            this.previewingId = `${schedule.id}:${format}`;
            try {
                const response = await Axios.get(`/api/sites/${this.siteId}/scheduled-reports/${schedule.id}/preview`, {
                    params: { format }, responseType: 'blob'
                });
                const url = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                const disposition = response.headers['content-disposition'] || '';
                const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i);
                const plain = disposition.match(/filename="([^"]+)"/i);
                link.download = encoded ? decodeURIComponent(encoded[1]) : plain ? plain[1] : `Report.${format}`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                setTimeout(() => URL.revokeObjectURL(url), 1000);
            } catch (error) {
                console.error('Report preview failed:', error);
                window.M.toast({ html: 'Unable to preview this report. Check its measurements and try again.' });
            } finally {
                this.previewingId = '';
            }
        },
        async generateReport(){
            console.time("Generate Reports")
            try {
                this.report = null;
                this.disableButtons = true
                let startTime = moment(this.startDate).tz(this.reportTimezone).startOf("day").valueOf();
                let endTime = moment(this.endDate).tz(this.reportTimezone).endOf('day').valueOf();
                if(this.selectedMeasurements.length  < 1){
                    console.error(`Please select measurements`)
                    window.M.toast({html: "Please select measurements"});
                    this.disableButtons = false;
                    return;
                }
                let res = await client.robustPost(`/api/sites/reports/${this.siteId}?startTime=${startTime}&endTime=${endTime}`, {
                    measurementIds: this.selectedMeasurements.map((el) => el.id),
                    timezone: this.reportTimezone
                });
                this.report = res.results.report;
                localStorage.setItem("report", JSON.stringify(res.results.report));

            } catch (error) {
                console.error(error);
                window.M.toast({html: "Cannot Generate Report"})
            } finally {
                this.disableButtons = false
            }
            console.timeEnd("Generate Reports")
        },
        updateStartDate(e){
            this.startDate = moment.tz(e, "YYYY-MM-DD", this.reportTimezone).valueOf();
            // console.log(`Start Date is ${this.startDate}`)
        },
        updateEndDate(e){
            this.endDate = moment.tz(e, "YYYY-MM-DD", this.reportTimezone).valueOf();
            // console.log(`End Date is ${this.endDate}`)
        },
        /**
         * @description Download the current report as an .xlsx workbook. Trend work runs in a worker so a large selection cannot freeze the tab.
         * @returns {Promise<void>}
         */
        async downloadExcel(){
            try {
                if (this.report == null) throw new Error("No Report to Download");
                this.generatingExcel = true;
                this.excelProgress = '';
                window.M.toast({html: this.includeTrendData ? "Generating Excel with all trend data..." : "Generating Excel..."});

                const reportData = this.report.data || [];
                const summaryRows = buildSummaryRows(reportData, {
                    title: this.reportTitle,
                    periodLabel: `Report Period: ${this.formatDate(this.startDate)} to ${this.formatDate(this.endDate)}`,
                    showScore: this.showScore === true
                });
                const startTime = moment(this.startDate).tz(this.reportTimezone).startOf("day").valueOf();
                const endTime = moment(this.endDate).tz(this.reportTimezone).endOf('day').valueOf();
                let series = [];
                let trendNotice = '';
                if (this.includeTrendData) {
                    const fetched = await this.fetchTrendSeries(reportData, startTime, endTime);
                    series = fetched.series;
                    const noSamples = series.length > 0 && fetched.empty + fetched.failed === series.length;
                    if (fetched.failed > 0 || noSamples) {
                        trendNotice = `Trend Data sheet may be incomplete. ${fetched.failed} trend requests failed and ${fetched.empty} returned no samples.`;
                    }
                }

                this.excelProgress = 'Building workbook...';
                await this.$nextTick();
                const buffer = await this.buildWorkbookInWorker({
                    summaryRows,
                    series,
                    includeTrendData: this.includeTrendData && series.length > 0,
                    timeZone: this.reportTimezone,
                    startTime,
                    endTime
                });
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${this.reportFilename}.xlsx`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                setTimeout(() => URL.revokeObjectURL(url), 1000);
                window.M.toast({html: trendNotice || "Excel download complete!"});
            } catch (error) {
                console.error(error);
                const tooLarge = error && error.code === 'TREND_EXPORT_TOO_LARGE';
                window.M.toast({html: tooLarge ? error.message : "Error generating Excel download"});
            } finally {
                this.generatingExcel = false;
                this.excelProgress = '';
            }
        },
        /**
         * @description Load numeric trend samples for the export without putting them in the Vuex cache.
         * @param {object[]} reportData
         * @param {number} startTime
         * @param {number} endTime
         * @returns {Promise<{series: {name: string, samples: Float64Array}[], failed: number, empty: number}>}
         */
        async fetchTrendSeries(reportData, startTime, endTime) {
            // getTrendData writes every sample into a reactive chart cache and starts a refresh timer.
            // That walk is what stalls the tab once hundreds of series are loaded, so the export reads the API directly.
            const measurementById = {};
            for (const measurement of this.selectedMeasurements) measurementById[measurement.id] = measurement;
            const trendItems = [];
            for (const row of reportData) {
                if (row.measurementKind === 'Bool') continue;
                const measurement = measurementById[row.measurementId];
                if (!measurement || !measurement.uuid) continue;
                const zone = (row.measurementZone && row.measurementZone !== 'site') ? row.measurementZone : '(Site)';
                trendItems.push({ measurement, name: `${zone} - ${row.measurementName}` });
            }
            const series = new Array(trendItems.length);
            let done = 0;
            let failed = 0;
            let empty = 0;
            const limit = Math.min(6, trendItems.length);
            let next = 0;
            const runOne = async () => {
                while (next < trendItems.length) {
                    const index = next++;
                    const item = trendItems[index];
                    let data = [];
                    let requestFailed = false;
                    try {
                        const trendData = await client.robustQuery('/api/trendData', {
                            siteId: this.siteId,
                            pointId: item.measurement.uuid,
                            version: 'highcharts',
                            startTime,
                            endTime,
                            type: item.measurement.type
                        });
                        if (trendData && trendData.results && trendData.results.data) data = trendData.results.data;
                    } catch (err) {
                        requestFailed = true;
                        console.error(`Failed to fetch trend data for ${item.measurement.name}:`, err);
                    }
                    if (requestFailed) failed += 1;
                    else if (data.length === 0) empty += 1;
                    const samples = new Float64Array(data.length * 2);
                    for (let i = 0; i < data.length; i++) {
                        samples[i * 2] = data[i][0];
                        const value = data[i][1];
                        samples[i * 2 + 1] = typeof value === 'number' ? value : Number.NaN;
                    }
                    series[index] = { name: item.name, samples };
                    done += 1;
                    this.excelProgress = `Fetching trend data ${done}/${trendItems.length}`;
                }
            };
            if (limit > 0) {
                this.excelProgress = `Fetching trend data 0/${trendItems.length}`;
                await Promise.all(Array.from({ length: limit }, () => runOne()));
            }
            return { series, failed, empty };
        },
        /**
         * @description Write the xlsx in a worker and return the file bytes.
         * @param {object} payload
         * @returns {Promise<ArrayBuffer>}
         */
        buildWorkbookInWorker(payload) {
            return new Promise((resolve, reject) => {
                const worker = createReportWorkbookWorker();
                let settled = false;
                const timeout = setTimeout(() => {
                    finish(new Error('Excel export timed out'));
                }, 120000);
                const finish = (error, buffer) => {
                    if (settled) return;
                    settled = true;
                    clearTimeout(timeout);
                    worker.terminate();
                    if (error) reject(error);
                    else resolve(buffer);
                };
                worker.onmessage = (event) => {
                    const data = event.data || {};
                    if (!data.ok) {
                        const error = new Error(data.error || 'Excel export failed');
                        error.code = data.code;
                        finish(error);
                        return;
                    }
                    finish(null, data.buffer);
                };
                worker.onerror = (event) => {
                    finish(new Error(event.message || 'Excel export failed'));
                };
                const transfer = [];
                for (const entry of payload.series || []) {
                    if (entry.samples && entry.samples.buffer && entry.samples.buffer.byteLength > 0) {
                        transfer.push(entry.samples.buffer);
                    }
                }
                worker.postMessage(payload, transfer);
            });
        },
        async downloadPDF() {
            try {
                if(this.report == null) throw new Error("No Report to Download")
                
                this.generatingPDF = true;
                this.pdfProgress = 'Preparing charts...';
                window.M.toast({html: "Generating PDF, please wait..."});
                
                // Use Highcharts native export - much faster than html2canvas
                const totalCharts = this.includeTrendData ? this.report.data.length : 0;
                const chartImages = [];
                
                this.pdfProgress = `Exporting ${totalCharts} chart${totalCharts !== 1 ? 's' : ''}...`;
                await this.$nextTick();
                
                // Get all Highcharts chart containers from the reports div
                const chartContainers = document.querySelectorAll('#reportsDiv .highcharts-container');
                console.log(`Found ${chartContainers.length} chart containers, expected ${totalCharts}`);
                
                // Get chart images from Highcharts instances
                for (let i = 0; i < totalCharts; i++) {
                    try {
                        this.pdfProgress = `Exporting chart ${i + 1} of ${totalCharts}...`;
                        await this.$nextTick();
                        
                        const container = chartContainers[i];
                        if (!container) {
                            console.warn(`Could not find chart container ${i}`);
                            chartImages.push(null);
                            continue;
                        }
                        
                        // Find the Highcharts instance for this container
                        const chart = Highcharts.charts.find(c => c && c.container === container);
                        
                        if (!chart) {
                            console.warn(`Could not find Highcharts instance for chart ${i}`);
                            console.log('Available Highcharts instances:', Highcharts.charts.filter(c => c).length);
                            chartImages.push(null);
                            continue;
                        }
                        
                        console.log(`Successfully found chart ${i}, size: ${chart.chartWidth}x${chart.chartHeight}`);
                        
                        // Export chart as SVG with better dimensions for PDF
                        // Use a fixed height to make charts more readable in PDF
                        const exportWidth = 800;  // Standard width
                        const exportHeight = 400; // Taller height for better visibility
                        
                        const svg = chart.getSVG({
                            chart: {
                                backgroundColor: '#ffffff',
                                width: exportWidth,
                                height: exportHeight
                            }
                        });
                        
                        // Convert SVG to canvas
                        const canvas = await this.svgToCanvas(svg, exportWidth, exportHeight);
                        chartImages.push(canvas);
                        
                    } catch (err) {
                        console.error(`Error exporting chart ${i}:`, err);
                        chartImages.push(null);
                    }
                }
                
                this.pdfProgress = 'Building PDF document...';
                await this.$nextTick();
                
                const pdf = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4', compress: true });
                pdf.setProperties({ title: this.reportTitle });
                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();
                const margin = 15;
                const contentWidth = pageWidth - (2 * margin);
                let yPosition = margin;
                
                // Helper function to add new page if needed
                const checkPageBreak = (requiredSpace) => {
                    if (yPosition + requiredSpace > pageHeight - margin) {
                        pdf.addPage();
                        yPosition = margin;
                        return true;
                    }
                    return false;
                };
                
                pdf.setFontSize(20);
                pdf.setFont(undefined, 'bold');
                const titleLines = pdf.splitTextToSize(this.reportTitle, contentWidth);
                pdf.text(titleLines, margin, yPosition);
                yPosition += titleLines.length * 8 + 3;
                pdf.setFontSize(10);
                pdf.setFont(undefined, 'normal');
                pdf.text(`Report Period: ${this.formatDate(this.startDate)} to ${this.formatDate(this.endDate)}`, margin, yPosition);
                yPosition += 12;

                // Layout constants sized to fit a 25-row hourly table plus chart on one A4 page.
                const rowHeight = 5;
                const chartMaxHeight = 65;
                const postTableSpacing = 8;
                const usablePageHeight = pageHeight - 2 * margin;

                // Report Data
                for (let i = 0; i < this.report.data.length; i++) {
                    this.pdfProgress = `Processing measurement ${i + 1} of ${this.report.data.length}...`;
                    await this.$nextTick();
                    const d = this.report.data[i];
                    const displayName = this.getDisplayName(d);

                    // Pre-calculate the total height this measurement block will need.
                    pdf.setFontSize(16);
                    const headingLines = pdf.splitTextToSize(displayName, contentWidth);
                    const headingHeight = headingLines.length * 7 + 3;
                    const intervalCount = d.intervals?.length || 0;
                    const tableHeight = rowHeight + intervalCount * rowHeight;
                    const chartSpace = chartImages[i] ? chartMaxHeight : 0;
                    const blockHeight = headingHeight + tableHeight + postTableSpacing + chartSpace;

                    // Determine if the entire block can fit on one page.
                    const fitsOnOnePage = blockHeight <= usablePageHeight;

                    if (fitsOnOnePage) {
                        // Block fits on one page: keep table and chart together.
                        checkPageBreak(blockHeight);
                    } else {
                        // Block is taller than one page; start fresh for consistency.
                        checkPageBreak(headingHeight + rowHeight * 2);
                    }
                    
                    // Measurement Title
                    pdf.setFont(undefined, 'bold');
                    pdf.setTextColor(33, 150, 243);
                    pdf.text(headingLines, margin, yPosition);
                    yPosition += headingHeight;
                    pdf.setTextColor(0, 0, 0);
                    
                    // Table
                    pdf.setFontSize(9);
                    const tableData = [];
                    const headers = d.measurementKind === 'Bool' 
                        ? ['Time Range', 'Count']
                        : this.showScore 
                            ? ['Time Range', 'Min Val', 'Max Val', 'Avg Val', 'Min Score', 'Max Score', 'Avg Score']
                            : ['Time Range', 'Min Val', 'Max Val', 'Avg Val'];
                    
                    for (let ii = 0; ii < intervalCount; ii++) {
                        const interval = d.intervals[ii];
                        if (d.measurementKind === 'Bool') {
                            tableData.push([interval.intervalName, interval.count.toString()]);
                        } else if (this.showScore) {
                            tableData.push([
                                interval.intervalName,
                                interval.minVal?.toFixed(2) || 'N/A',
                                interval.maxVal?.toFixed(2) || 'N/A',
                                interval.aveVal?.toFixed(2) || 'N/A',
                                interval.minScore?.toFixed(2) || 'N/A',
                                interval.maxScore?.toFixed(2) || 'N/A',
                                interval.aveScore?.toFixed(2) || 'N/A'
                            ]);
                        } else {
                            tableData.push([
                                interval.intervalName,
                                interval.minVal?.toFixed(2) || 'N/A',
                                interval.maxVal?.toFixed(2) || 'N/A',
                                interval.aveVal?.toFixed(2) || 'N/A'
                            ]);
                        }
                    }
                    
                    // Draw table manually
                    const firstColWidth = this.showScore && headers.length > 4 ? 36 : contentWidth / headers.length;
                    const colWidth = (contentWidth - firstColWidth) / (headers.length - 1);
                    const columnX = idx => margin + (idx === 0 ? 0 : firstColWidth + (idx - 1) * colWidth) + 2;
                    
                    // Helper to draw table header row
                    const drawTableHeader = () => {
                        pdf.setFont(undefined, 'bold');
                        pdf.setFillColor(245, 245, 245);
                        pdf.rect(margin, yPosition, contentWidth, rowHeight, 'F');
                        headers.forEach((header, idx) => {
                            pdf.text(header, columnX(idx), yPosition + 4);
                        });
                        yPosition += rowHeight;
                        pdf.setFont(undefined, 'normal');
                    };

                    drawTableHeader();
                    
                    // Draw rows
                    pdf.setFont(undefined, 'normal');
                    for (let row of tableData) {
                        // For blocks taller than one page, check for page break per row.
                        if (!fitsOnOnePage && checkPageBreak(rowHeight)) {
                            // Redraw continued header on new page
                            const continued = pdf.splitTextToSize(`${displayName} (continued)`, contentWidth);
                            pdf.text(continued, margin, yPosition);
                            yPosition += continued.length * 4 + 4;
                            drawTableHeader();
                        }

                        row.forEach((cell, idx) => {
                            pdf.text(cell, columnX(idx), yPosition + 4);
                        });
                        
                        // Draw row border
                        pdf.setDrawColor(221, 221, 221);
                        pdf.rect(margin, yPosition, contentWidth, rowHeight);
                        yPosition += rowHeight;
                    }
                    
                    yPosition += postTableSpacing;
                    
                    // Add pre-exported chart
                    if (chartImages[i]) {
                        // For blocks that don't fit on one page, check if chart fits here or needs new page.
                        if (!fitsOnOnePage) {
                            checkPageBreak(chartMaxHeight);
                        }

                        try {
                            const imgData = chartImages[i].toDataURL('image/jpeg', 0.85);
                            
                            // Calculate dimensions maintaining aspect ratio, capped to fit
                            const canvasWidth = chartImages[i].width;
                            const canvasHeight = chartImages[i].height;
                            const aspectRatio = canvasHeight / canvasWidth;
                            
                            const chartWidthInPDF = contentWidth;
                            let chartHeightInPDF = Math.min(chartWidthInPDF * aspectRatio, chartMaxHeight);
                            
                            pdf.addImage(imgData, 'JPEG', margin, yPosition, chartWidthInPDF, chartHeightInPDF);
                            yPosition += chartHeightInPDF + 5;
                        } catch (imgErr) {
                            console.error(`Error adding chart ${i} to PDF:`, imgErr);
                        }
                    }
                }
                
                // Save the PDF
                this.pdfProgress = 'Finalizing PDF...';
                await this.$nextTick();
                
                for (let page = 1; page <= pdf.internal.getNumberOfPages(); page++) {
                    pdf.setPage(page);
                    pdf.setFontSize(8);
                    pdf.text(`Page ${page} of ${pdf.internal.getNumberOfPages()}`, pageWidth - margin, pageHeight - 7, { align: 'right' });
                }
                pdf.save(`${this.reportFilename}.pdf`);
                
                this.pdfProgress = '';
                window.M.toast({html: "PDF download complete!"});
            } catch (error) {
                console.error(error);
                this.pdfProgress = '';
                window.M.toast({html: "Error generating PDF download"});
            } finally {
                this.generatingPDF = false;
                this.pdfProgress = '';
            }
        },
        formatDate(timestamp) {
            return moment(timestamp).tz(this.reportTimezone).format('MMMM D, YYYY');
        },
        async svgToCanvas(svgString, width, height) {
            return new Promise((resolve, reject) => {
                const canvas = document.createElement('canvas');
                // Use the actual dimensions without scaling to preserve aspect ratio
                canvas.width = width;
                canvas.height = height;
                
                const ctx = canvas.getContext('2d');
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, width, height);
                
                const img = new Image();
                const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
                const url = URL.createObjectURL(svgBlob);
                
                img.onload = () => {
                    ctx.drawImage(img, 0, 0, width, height);
                    URL.revokeObjectURL(url);
                    console.log(`Canvas created: ${width}x${height}, aspect ratio: ${height/width}`);
                    resolve(canvas);
                };
                
                img.onerror = (err) => {
                    console.error('SVG to canvas conversion error:', err);
                    URL.revokeObjectURL(url);
                    reject(err);
                };
                
                img.src = url;
            });
        }
    },
    computed: {
        selectedDeviceNames() {
            return [...new Set(this.selectedMeasurements.map(m => m.zoneName || '(Site)'))].sort();
        },
        reportTitle() {
            return this.reportName.trim() || `${this.site?.name || 'Site'} Report`;
        },
        reportFilename() {
            // Strip control characters and reserved filename characters.
            // eslint-disable-next-line no-control-regex
            const title = this.reportTitle.replace(/[\x00-\x1f<>:"/\\|?*]/g, '').trim().slice(0, 160) || 'Report';
            return `${title} - ${moment().format('MM-DD-YYYY')}`;
        },
        getDisplayName(){
          return (d) => {
               return d.measurementName + ` (${d.measurementZone || "(Site)"})`
          }
        },
        showScore(){
            return this.site?.aqEnabled === false ? false: true 
        },
        measurementTypeGroups() {
            if(!this.report || !this.report.data) return [];
            const types = [...new Set(this.report.data.map(d => d.measurementType))];
            return types.sort();
        },
        getReportsByType() {
            return (typeName) => {
                if(!this.report || !this.report.data) return [];
                return this.report.data.filter(d => d.measurementType === typeName);
            };
        }
    },
    mounted(){
        this.reloadFromRoute();
    },
    watch: {
        startDate() { this.report = null; },
        endDate() { this.report = null; },
        reportTimezone() { this.report = null; },
        '$route.params.siteId'() {
            this.reloadFromRoute();
        }
    }
}
</script>